import Vue from "vue";
import VueRouter from "vue-router";
import LightBootstrap from "./light-bootstrap-main";
import store from "./store";
// Plugins
import App from "./App.vue";

import VueSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

Vue.component('vue-select', VueSelect);

import vSelectSearch from 'v-select-search';

Vue.use(vSelectSearch);

// Element
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import elementLocale from "element-ui/lib/locale/lang/en";
Vue.use(ElementUI, { locale: elementLocale });
Vue.use(ElementUI);

// router setup
import routes from "./routes/routes";
// plugin setup
Vue.use(VueRouter);
Vue.use(LightBootstrap);
// google map
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCBthI5roOq2y_tePg6Mpeag4QoklXZF6Q",
    libraries: "places", // necessary for places input
  },
});
// import { gmapApi } from "vue2-google-maps";
// Vue.use(gmapApi)


import VueCookies from "vue-cookies";
Vue.use(VueCookies);

import Viewer from "v-viewer";
import VueViewer from "v-viewer";
Vue.use(Viewer);
Vue.use(VueViewer);

import VueVideoPlayer from "vue-video-player";
import "video.js/dist/video-js.css";
Vue.use(VueVideoPlayer);

// Vee Validation
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
extend("required", {
  ...required,
  message: "Sahə mütləqdir!",
});
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

// Print setup
import Print from 'vue-print-nb'

Vue.use(Print);

//Pagination setup
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import Chart from "vue-frappe-chart"

Vue.use(Chart)


Vue.component('v-select', VueSelect.VueSelect);
// Directives
Vue.directive('upper', {
  bind(el, _, vnode) {
    el.addEventListener('input', (e) => {
      let letters = { "i": "İ", "ş": "Ş", "ğ": "Ğ", "ü": "Ü", "ö": "Ö", "ç": "Ç", "ı": "I" };
      let string = e.target.value.replace(/(([iışğüçö]))+/g, function (letter) { return letters[letter]; })
      vnode.componentInstance.$emit('input', string.toUpperCase())
    })
  }
})
Vue.directive('decimal', {
  bind(el, binding, vnode) {
    let inputElement = el.querySelector('input');

    if (inputElement) {
      inputElement.addEventListener('input', () => {
        let regex = /^[0-9]*[.,]?[0-9]{0,2}$/;
        if (!regex.test(inputElement.value)) {
          inputElement.value = inputElement.value.slice(0, -1);
          inputElement.dispatchEvent(new Event('input'));
        }
      });
    }
  }
});
Vue.directive('lower', {
  bind(el, _, vnode) {
    el.addEventListener('input', (e) => {
      let letters = { "i": "İ", "ş": "Ş", "ğ": "Ğ", "ü": "Ü", "ö": "Ö", "ç": "Ç", "ı": "I" };
      let string = e.target.value.replace(/(([İIŞĞÜÇÖ]))+/g, function (letter) { return letters[letter]; })
      vnode.componentInstance.$emit('input', string.toLowerCase())
    })
  }
})
Vue.directive('letter', {
  bind(el, _, vnode) {
    el.addEventListener('input', (e) => {
      e.target.value = e.target.value.replace(/[^ƏÜĞÖİIÇŞA-Z ] /, "");
      vnode.componentInstance.$emit('input', e.target.value.replace(/[^ƏÜĞÖİIÇŞA-Z ]/, ""));
    })
  }
})
Vue.directive('capitalize', {
  inserted(el, binding) {
    formatText(el);
  },
  componentUpdated(el) {
    formatText(el);
  }
});

function formatText(el) {
  const text = el.textContent || el.value;
  if (text && text.length > 0) {
    const formatted = text.charAt(0).toLocaleUpperCase('tr-TR') + 
                     text.slice(1).toLocaleLowerCase('tr-TR');
    
    if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
      el.value = formatted;
    } else {
      el.textContent = formatted;
    }
  }
}
const router = new VueRouter({
  routes,
  linkActiveClass: "active",
  scrollBehavior(to, from, savedPosition) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        window.scrollTo(0, 0);
        resolve({ left: 0, top: 0 });
      }, 1000);
    });
  },
});
import { LoadUser, GetSession } from "./services/localstate";
import { login } from "./services/helper";
router.beforeEach(async (to, from, next) => {
  const metaauth = to.matched.find((record) => record.meta.requiresAuth);

  let timeout;


  if (metaauth && !GetSession()) {
    await store.dispatch('logout');
    window.location.replace(login);
    return;
  }

  function logout() {
    store.dispatch("logout");
      next({
        path: "/session/LOGOUT",
      });
    window.location.replace(login);
    return;
  }
  if (to.path === "/logout") {
    logout();
  }

  if (metaauth) {
    let user = store.state.user;
    if (!user) {
      next({
        path: "/session/LOGOUT",
      });
    } else {
      if (!user.roles) {
        user = await LoadUser();
      }
      if (!user) {
        next({
          path: "/session",
        });
        return;
      }
      const roleints = metaauth.meta.role.filter(value => user.roles.includes(value));

      if (roleints.length > 0 || metaauth.meta.role === "ANY") {
        next();
      } else {
        next({
          path: "/accessdenied",
        });
      }
    }
  } else {
    next();
  }
});

import { i18n } from './services/lang/i18n'

Vue.use(i18n);
/* eslint-disable no-new */
new Vue({
  el: "#app",
  i18n,
  render: (h) => h(App),
  store,
  router,
  beforeCreate() {
    this.$store.commit("initialiseStore");
  },
});
